export default __webpack_public_path__ + "static/media/UniversLTStd-BlackExObl.c16e23cd.otf";